import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { Reveal } from "@/components/Reveal";
import { DynIcon } from "@/components/DynIcon";
import { Eyebrow } from "@/components/Ui";
import { ArrowRight } from "lucide-react";

export default function About() {
  const { t } = useLang();
  const values = t("about.values");

  return (
    <div data-testid="about-page">
      <section className="bg-grid">
        <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 py-16 sm:px-6 lg:grid-cols-2 lg:py-20">
          <div>
            <Reveal>
              <Eyebrow>{t("about.eyebrow")}</Eyebrow>
              <h1 className="mt-3 font-display text-4xl font-bold text-marine sm:text-5xl">{t("about.title")}</h1>
            </Reveal>
            <Reveal delay={120}>
              <p className="mt-5 text-base leading-relaxed text-slate-500 md:text-lg">{t("about.intro")}</p>
            </Reveal>
            <Reveal delay={220}>
              <div className="mg-card mt-8 border-l-4 !border-l-gold p-6">
                <h2 className="font-display text-lg font-bold text-marine">{t("about.missionTitle")}</h2>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{t("about.mission")}</p>
              </div>
            </Reveal>
          </div>
          <Reveal delay={200} className="relative">
            <div className="absolute -inset-3 rounded-3xl border-2 border-gold/40" aria-hidden="true" />
            <img src="/brand/team.jpg" alt="MANAGONE" className="relative w-full rounded-2xl object-cover shadow-2xl shadow-marine/20" data-testid="about-team-image" />
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6">
        <Reveal className="text-center">
          <h2 className="font-display text-3xl font-bold text-marine sm:text-4xl">{t("about.valuesTitle")}</h2>
        </Reveal>
        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {values.map((v, i) => (
            <Reveal key={v.title} delay={i * 100}>
              <div className="mg-card h-full p-6 text-center" data-testid={`value-${i}`}>
                <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-xl bg-marine text-gold">
                  <DynIcon name={v.icon} className="h-6 w-6" />
                </div>
                <h3 className="mt-4 font-display text-lg font-bold text-marine">{v.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-500">{v.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-marine">
        <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 py-20 sm:px-6 lg:grid-cols-2">
          <Reveal>
            <img src="/brand/industry.jpg" alt="MANAGONE" className="w-full rounded-2xl object-cover shadow-2xl" data-testid="about-industry-image" />
          </Reveal>
          <Reveal delay={150}>
            <h2 className="font-display text-3xl font-bold text-white sm:text-4xl">{t("about.teamTitle")}</h2>
            <p className="mt-4 text-base leading-relaxed text-slate-300">{t("about.teamText")}</p>
            <Link to="/contact" className="btn-gold mt-8" data-testid="about-cta-button">
              {t("about.cta")} <ArrowRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
